import { AdapterCache } from 'customer-data-filters-ui/fetcher/requestCaches/adaptersCache';
import { isAdapterConfigUsingCustomCaching } from 'customer-data-filters-ui/fetcher/adapter/adapterConfigs/AdapterConfigUsingCustomCaching';
import { isAdapterConfigUsingDefaultCaching } from 'customer-data-filters-ui/fetcher/adapter/adapterConfigs/AdapterConfigUsingDefaultCaching';
export default class Adapter {
  constructor(adapterConfig) {
    this.adapterConfig = adapterConfig;
    this.fetchedDataCache = new AdapterCache();
    this.formattedDataCache = new AdapterCache();
  }
  static makeFromConfig(AdapterConfig) {
    const adapterConfig = new AdapterConfig();
    return new this(adapterConfig);
  }
  isAssetFamilySupported(assetFamily) {
    return this.adapterConfig.isAssetFamilySupported(assetFamily);
  }
  getFetchedData(assetFamily, variables = {}, props = {}) {
    if (!isAdapterConfigUsingDefaultCaching(this.adapterConfig)) {
      const fetcher = this.adapterConfig.getFetcher(assetFamily, props);
      return this.adapterConfig.fetchData(fetcher, assetFamily, variables);
    }
    const cacheKey = this.adapterConfig.getCacheKey(assetFamily);
    const cachedFetchedData = this.fetchedDataCache.get(cacheKey);
    if (cachedFetchedData) {
      return cachedFetchedData;
    }
    const fetcher = this.adapterConfig.getFetcher(assetFamily, props);
    const fetchedData = this.adapterConfig.fetchData(fetcher, assetFamily, variables);
    this.fetchedDataCache.set(cacheKey, fetchedData);
    return fetchedData;
  }
  getFormattedData(assetFamily, response, previousFormattedData) {
    if (!isAdapterConfigUsingDefaultCaching(this.adapterConfig)) {
      return this.adapterConfig.formatData(response, assetFamily, previousFormattedData);
    }
    const cacheKey = this.adapterConfig.getCacheKey(assetFamily);
    const cachedFormattedData = this.formattedDataCache.get(cacheKey);
    if (cachedFormattedData) {
      return cachedFormattedData;
    }
    const formattedData = this.adapterConfig.formatData(response, assetFamily, previousFormattedData);
    this.formattedDataCache.set(cacheKey, formattedData);
    return formattedData;
  }
  clearCache(assetFamily, props = {}) {
    if (isAdapterConfigUsingDefaultCaching(this.adapterConfig)) {
      const cacheKey = this.adapterConfig.getCacheKey(assetFamily);
      this.fetchedDataCache.clear(cacheKey);
      this.formattedDataCache.clear(cacheKey);
    }
    if (isAdapterConfigUsingCustomCaching(this.adapterConfig)) {
      this.adapterConfig.clearCache(assetFamily, props);
    }
  }
  clearCacheAll() {
    this.fetchedDataCache.clearAll();
    this.formattedDataCache.clearAll();
    if (isAdapterConfigUsingCustomCaching(this.adapterConfig)) {
      this.adapterConfig.clearCacheAll();
    }
  }
}